export default "__VITE_ASSET__DU2J3IQc__"